import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import StandardTableVue from '../../../components/table/StandardTable.vue';
import { getErpGroupList, deleteErpByid } from '@/services/customer/erpGrouped';
import moment from 'moment';
export default {
  components: {
    StandardTableVue: StandardTableVue
  },
  i18n: require("./i18n-dyx"),
  data: function data() {
    var _this = this;
    var columns = [{
      dataIndex: 'groupName',
      title: this.$t('account.groupName')
    }, {
      title: this.$t('account.dyxCount'),
      dataIndex: 'erpCustomerTotal'
    }, {
      title: this.$t('account.createUser'),
      dataIndex: 'createUserName'
    }, {
      title: this.$t('account.updateTime'),
      dataIndex: 'createTime',
      scopedSlots: {
        customRender: 'time'
      }
    }, {
      title: this.$t('emailAction'),
      dataIndex: 'action',
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      search: {
        title: '',
        content: ''
      },
      data: [],
      columns: columns,
      moment: moment,
      loadingTable: false,
      pagination: {
        pageSizeOptions: ['10', '20', '30'],
        total: 0,
        showTotal: function showTotal(total, r) {
          return "".concat(_this.$t('account.total')).concat(total);
        },
        pageSize: 10,
        current: 1,
        showSizeChanger: true
      }
    };
  },
  mounted: function mounted() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this2.loadingTable = true;
              params = {
                groupName: _this2.search.title,
                erpCustomerInfo: _this2.search.content,
                page: _this2.pagination.current,
                size: _this2.pagination.pageSize
              };
              _context.p = 1;
              _context.n = 2;
              return getErpGroupList(params);
            case 2:
              res = _context.v;
              if (res.data.code == 200) {
                _this2.data = res.data.data.list;
                _this2.pagination.total = res.data.data.total;
              }
            case 3:
              _context.p = 3;
              _this2.loadingTable = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1,, 3, 4]]);
      }))();
    },
    queryDyx: function queryDyx() {
      this.pagination.current = 1;
      this.initData();
    },
    add: function add() {
      this.$router.push({
        path: '/dyxDisGroup/adddyx'
      });
    },
    Edit: function Edit(row) {
      this.$router.push({
        path: '/dyxDisGroup/editdyx',
        query: {
          id: row.groupId
        }
      });
    },
    deleteGroup: function deleteGroup() {},
    confirmDelete: function confirmDelete(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this3.loadingTable = true;
              _context2.n = 1;
              return deleteErpByid(row.groupId);
            case 1:
              res = _context2.v;
              if (_this3.data.length == 1) {
                _this3.pagination.current = _this3.pagination.current - 1;
              }
              if (res.data.code == 200) {
                _this3.$message.success(_this3.$t('public.deleteSuccessfully'));
                _this3.initData();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    cancelDelete: function cancelDelete() {},
    changePage: function changePage(e) {
      this.pagination.current = e.current;
      this.pagination.pageSize = e.pageSize;
      this.initData();
    },
    showSizeChange: function showSizeChange(e) {
      console.log(e);
    }
  }
};